const messages = {
  fleetWithOptions:
    "Ne možete izabrati flotu ako ste izabrali opcije",
  addProduct: "Vaš proizvod je dodan u korpu.",
  addProducts: "Vaši proizvodi su dodani u korpu.",
  profileSaved: "Podaci vašeg profila su sačuvani",
  canAddProduct: "Nemate dovoljno bodova.",
  customerNumberSaved: "Broj kupca sačuvan",
  customerNumberExist: "Broj kupca dostupan",
  complaintForm: "Vaš zahtjev je prihvaćen. Molimo sačekajte odgovor",
  openHourSaved: "Radno vrijeme je sačuvano",
  changeParentId:
    "Ne možete mijenjati podružnicu sa većim brojem kupca ako ima podređene podružnice.",
  requestSent: "Zahtjev je poslan",
  completeProfileRequired:
    "Morate popuniti vaš profil 100% da biste mogli nastaviti sa kupovinama u shopu.",
  accessDenied: "Pristup odbijen",
  incomplete_address: "Adresa je nepotpuna. Molimo provjerite",
  waitMoment: "Sačekajte trenutak",
  downloadFinished: "Preuzimanje završeno",
  selectOneField: "Izaberite jedno polje",
  noVoucher: "Vaučer nije pronađen",
  cannotAddCsNumber: "Ne možete dodati broj kupca",
  messagesDeletedSuccess: "Poruke su obrisane.",
  messagesDeletedError: "Brisanje poruka nije uspelo.",
  fillProfile: "Popunite profil da biste mogli preuzeti certifikat,",
  favoriteAdded: "Dodano u omiljene.",
  favoriteRemoved: "Uklonjeno iz omiljenih.",
};

export default {
  messages,
};
